import { url } from "inspector";
import CheckIcon from "../../Assets/check-icon.svg";
import lol from "../../Assets/KPIS/1.png";
const WhatCanYouExpect = () => {
  return (
    <div className="bg-white py-16 w-full">
      <div className="max-w-[1400px] flex flex-col items-center mx-auto container">
        <h2 className="text-black font-bold max-lg:hidden block mb-10 text-[2rem]">
          WHAT YOU CAN EXPECT{" "}
        </h2>

        <p className="text-black font-semibold text-[1.5rem]">
          Target Results & KPIs
        </p>
        <p className="text-black mb-10">3-Month Sales Campaign</p>

        <div className="max-lg:grid max-lg:grid-cols-2 max-lg:gap-5 max-lg:px-6 flex w-full gap-1 flex-wrap  items-center lg:justify-evenly">
          {[1, 2, 3, 4, 5].map((item, index) => {
            return <img src={require(`../../Assets/KPIS/${item}.png`)} className="w-fit justify-self-center" />;
          })}
        </div>

        <div className="flex max-lg:hidden block mt-10 items-center gap-4">
          <img src={CheckIcon} className="h-7" />
          <p className="font-medium">
            Reporting & Campaign Optimization as we go
          </p>
        </div>
      </div>
    </div>
  );
};

export default WhatCanYouExpect;
